module.exports = __webpack_public_path__ + "img/GRANDE_headerbanner.332353a7.png";